<!--  -->
<template>
  <el-card shadow="never" class="aui-card--fill">
    <div>
      <offbaseAdd v-show="offbaseAdd" :isbasicinfo="isSaveOffbase" :message="offeringMsg" :isShowEdit="isShowEdit" :passOfferingId="passOfferingId" @onShowModer="vOnShowModer" @onOfferingMsg="vOnOfferingMsg" @onOfferingId="vOnOfferingId"/>
      <offeringResources v-show="offeringResourcesAdd" :message="offeringMsg" :isShowEdit="isShowEdit" :passOfferingId="passOfferingId" @onShowModer="vOnShowModer" />
      <offconditionAdd v-show="offconditionAdd" :message="offeringMsg" :isShowEdit="isShowEdit" :passOfferingId="passOfferingId" @onShowModer="vOnShowModer" />
      <offnoticeAdd v-show="offnoticeAdd" :message="offeringMsg" :passOfferingId="passOfferingId" @onShowModer="vOnShowModer" />
      <offpriceAdd v-show="offpriceAdd" :message="offeringMsg" :passOfferingId="passOfferingId" @onShowModer="vOnShowModer" />
      <offinvestAdd v-show="offinvestAdd" :message="offeringMsg" :passOfferingId="passOfferingId" @onShowModer="vOnShowModer" />
      <offabilityAdd v-show="offabilityAdd" :message="offeringMsg" :passOfferingId="passOfferingId" :issaveall="isSaveAll" @onShowModer="vOnShowModer" />
      <offeringEnd v-show="offeringEnd"></offeringEnd>
    </div>
  </el-card>
</template>

<script>
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd

import offbaseAdd from './offeringBaseInfo/show'
import offeringResources from './offeringResources/show'
import offconditionAdd from './signUpConditions/show'
import offnoticeAdd from './signUpNotice/show'
import offpriceAdd from './priceCorrelation/show'
import offinvestAdd from './questionInvestigation/show'
import offabilityAdd from './abilityItems/show'
import offeringEnd from './releaseSuccess'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    offbaseAdd,
    offeringResources,
    offconditionAdd,
    offnoticeAdd,
    offpriceAdd,
    offinvestAdd,
    offabilityAdd,
    offeringEnd
  },
  data () {
    // 这里存放数据
    return {
      offeringResourcesAdd: false,
      offeringMsg: '',
      isShowEdit: '',
      offeringId: '',
      passOfferingId: '',
      offbaseAdd: true,
      offconditionAdd: false,
      offpriceAdd: false,
      offnoticeAdd: false,
      offabilityAdd: false,
      offinvestAdd: false,
      offeringEnd: false,
      // 控制每一页是否保存成功
      isSaveAll: false,
      isSaveOffbase: false,
      isSaveOffcondition: false,
      isSaveOffnotice: true,
      isSaveOffprice: true,
      isSaveOffability: true,
      isSaveOffinvest: true

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    console.log('created')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.$eventHub.$on('showViewOffering', (data) => {
      this.offbaseAdd = true
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      this.offeringEnd = false

      this.offeringMsg = ''

      console.log("showViewOffering data")
      console.log(data)
      this.isShowEdit = data
      this.passOfferingId = ''
    })
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    // 这里处理初始化数据 每次进来都会触发
    // if (this.$route.query.courseId !== null && this.$route.query.courseId !== undefined) {
    //   console.log('activated....')
    //   console.log(this.$route.query.courseId)
    // }
      this.getOfferingPrice()
  },
    // 初始化数据
    getOfferingPrice () {
        console.log(this.$route.query.offeringId)
        if (this.$route.query.offeringId) {
            this.inServForm.offeringId = this.$route.query.offeringId
        }
        if (this.inServForm.offeringId === null || this.inServForm.offeringId === '') {
            return
        }
        this.$request.get('/learning/base/offeringinfo/get/' + this.inServForm.offeringId
        ).then((res, total, code, data) => {
            if (data.data !== undefined && data.data !== null) {
                this.inServForm = data.data
            }
        }).catch((err) => {
          console.log(err)
        })
    },
  provide () {
    return {
      toTop: this.toTop
    }
  },
  // 方法集合
  methods: {
    // 回到顶部
    toTop: function () {
      window.scrollTo(0, 0)
    },
    // 获取课程状态 判断是否
    init: function (offeringId) {
      console.log(offeringId)
    },

    vOnOfferingMsg: function (offeringMsg) {
      this.offeringMsg = offeringMsg
    },
    vOnOfferingId: function (passOfferingId) {
      this.passOfferingId = passOfferingId
    },
    vOnShowModer: function (childValue) {
      switch (childValue) {
        // 点击圈圈
        case 'offbaseAdd':
          this.onOffbase()
          break
        case 'offeringResourcesAdd':
          this.onOfferingResources()
          break
        case 'offconditionAdd':
          this.onOffcondition()
          break
        case 'offpriceAdd':
          this.onOffnotice()
          break
        case 'offnoticeAdd':
          this.onOffprice()
          break
        case 'offinvestAdd':
          this.onOffinvest()
          break
        case 'offabilityAdd':
          this.onOffability()
          break
          // 最后一步 完成
        case 'offeringEnd':
          this.onCourseend()
          break
          // 点击下一步
        case 'offbasesend':
          this.onOffbaseSend()
          break
        case 'offeringResourcessend':
          this.onOfferingResourcesSend()
          break
        case 'offconditionsend':
          this.onOffconditionSend()
          break
        case 'offnoticesend':
          this.onOffnoticeSend()
          break
        case 'offpricesend':
          this.onOffpriceSend()
          break
        case 'offinvestsend':
          this.onOffinvestSend()
          break
        case 'offabilitysend':
          this.onOffabilitySend()
          break
        case 'offconditionSave':
          this.onOffconditionSave()
          break
        case 'offeringResourcesSave':
          this.onOfferingResourcesSave()
          break
        case 'offnoticeSave':
          this.onOffnoticeSave()
          break
        case 'offpriceSave':
          this.onOffpriceSave()
          break
        case 'OffinvestSave':
          this.onOffinvestSave()
          break
        case 'offabilitySave':
          this.onOffabilitySave()
          break
        default:
          // text = '期待周末~'
      }
    },
    // 点击圈圈处理
    onOffbase: function (childValue) {
      this.offbaseAdd = true
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      // this.isSaveOffbase = true
      // this.watchIsSaveAll()
    },
    // 点击圆圈 排期资源
    onOfferingResources: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = true
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
    },
    onOffcondition: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = true
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      // this.isSaveOffbase = true
      this.watchIsSaveAll()
    },
    onOffnotice: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = true
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      // this.isSaveOffcondition = true
      this.watchIsSaveAll()
    },
    onOffprice: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = true
      this.offabilityAdd = false
      this.offinvestAdd = false
      // this.isSaveOffnotice = true
      this.watchIsSaveAll()
    },
    onOffinvest: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = true
      // this.isSaveOffprice = true
      this.watchIsSaveAll()
    },
    onOffability: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = true
      this.offinvestAdd = false
      // this.isSaveOffinvest = true
      this.watchIsSaveAll()
    },
    //  最后一步处理
    onOffbaseSend: function (childValue) {
      this.offbaseAdd = true
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      // this.isSaveOffbase = true
      // this.watchIsSaveAll()
    },
    // 点击下一步处理 排期资源
    onOfferingResourcesSend: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = true
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      this.isSaveOffbase = true
      this.watchIsSaveAll()
    },
    // 点击下一步处理
    onOffconditionSend: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = true
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      this.isSaveOffbase = true
      this.watchIsSaveAll()
    },
    onOffnoticeSend: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offnoticeAdd = true
      this.offpriceAdd = false
      this.offinvestAdd = false
      this.offabilityAdd = false

      this.isSaveOffcondition = true
      this.watchIsSaveAll()
    },
    onOffpriceSend: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offnoticeAdd = false
      this.offpriceAdd = true
      this.offinvestAdd = false
      this.offabilityAdd = false

      this.isSaveOffnotice = true
      this.watchIsSaveAll()
    },
    onOffinvestSend: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offnoticeAdd = false
      this.offpriceAdd = false
      this.offinvestAdd = true
      this.offabilityAdd = false

      this.isSaveOffprice = true
      this.watchIsSaveAll()
    },
    onOffabilitySend: function (childValue) {
      this.offbaseAdd = false
      this.offeringResourcesAdd = false
      this.offconditionAdd = false
      this.offnoticeAdd = false
      this.offpriceAdd = false
      this.offinvestAdd = false
      this.offabilityAdd = true

      this.isSaveOffinvest = true
      this.watchIsSaveAll()
    },
    // 点击下一步处理结束
    // 点击保存按钮开始
    onOffconditionSave: function (childValue) {
      this.isSaveOffbase = true
      this.watchIsSaveAll()
    },
    onOffnoticeSave: function (childValue) {
      this.isSaveOffcondition = true
      this.watchIsSaveAll()
    },
    onOffpriceSave: function (childValue) {
      this.isSaveOffnotice = true
      this.watchIsSaveAll()
    },
    onOffinvestSave: function (childValue) {
      this.isSaveOffprice = true
      this.watchIsSaveAll()
    },
    onOffabilitySave: function (childValue) {
      this.isSaveOffinvest = true
      this.watchIsSaveAll()
    },
    // 点击保存按钮结束
    onCourseend: function (childValue) {
      this.offbaseAdd = false
      this.offconditionAdd = false
      this.offpriceAdd = false
      this.offnoticeAdd = false
      this.offabilityAdd = false
      this.offinvestAdd = false
      this.offeringEnd = true
      this.isSaveOffinvest = true
      this.watchIsSaveAll()
    },
    // 判断所有页面是否保存
    watchIsSaveAll: function () {
      console.log('.................')
      console.log(this.isSaveOffbase)
      console.log(this.isSaveOffcondition)
      console.log(this.isSaveOffnotice)
      console.log(this.isSaveOffinvest)
      console.log(this.isSaveOffprice)
      console.log(this.isSaveOffability)
      if (this.isSaveOffbase && this.isSaveOffcondition && this.isSaveOffnotice && this.isSaveOffprice && this.isSaveOffinvest) {
        this.isSaveAll = true
      }
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped >
</style>
